import axios from "axios";
import { useMutation, useQueryClient } from "react-query";

export const  useUpdateSaveAnswers =({reportName}) => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async ({body, config}) => {
        return axios.post(`${process.env.REACT_APP_API_URI}Save`, body,config);
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['workbench', reportName])
      }
    });
  }